import * as React from "react";
import type { SVGProps } from "react";

const SvgChartPie = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
        <path
            fill="currentColor"
            d="M13 0v2.05a9.99 9.99 0 0 1 7.091 4.072l1.771-1.033.5.862A12 12 0 1 1 12 0Zm-2 2.049a9.994 9.994 0 1 0 10.1 5.8L11 13.741Zm2 2.013v6.195l5.353-3.121A7.99 7.99 0 0 0 13 4.062Z"
        />
    </svg>
);
export default SvgChartPie;
